import _ from 'lodash';
import React, { Component } from 'react';
import { func, object } from 'prop-types';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import s from './ReportsContent.module.css';
import { PRODUCT_MODELS } from '../../../util/constants';
import SkillsOverviewReport from '../skillsOverviewReport/SkillsOverviewReport';
import ModuleOverview from '../ModuleOverview/ModuleOverview';
import ReportError from '../ReportError';
import LeftHandNav from '../../../../components/LeftHandNav';
import { getCourseAbstract, sendAnalyticsEvent, loadUnits, getSkillsNavigationData } from '../../../actions/reports';
import { viewReport } from '../../../analyticsEvents';
import { REPORT_TYPES } from '../../../actions/constants';
import { getConfigObject } from '../../../util/config';

class ReportsContent extends Component {
  async componentDidMount() {
    const { FF_PT_385 = false } = getConfigObject();
    const productModelId = _.get(this.props, 'reports.courseAbstract.productModelId');
    this.sendAnalytics(productModelId);

    const supportsQQInsights = (productModelId === PRODUCT_MODELS.qualitative ||
      productModelId === PRODUCT_MODELS.quantitative ||
      (productModelId === PRODUCT_MODELS.essentials && FF_PT_385) ||
      productModelId === PRODUCT_MODELS.goreact
    );
    const isSkills = productModelId === PRODUCT_MODELS.skills;

    const courseId = _.get(this.props, 'reports.courseAbstract.id');

    if (supportsQQInsights) {
      await this.props.loadUnits(courseId);
    } else if (isSkills) {
      await this.props.getSkillsNavigationData(courseId);
    }
  }

  componentWillReceiveProps(newProps) {
    const newProductModelId = _.get(newProps, 'reports.courseAbstract.productModelId');
    if (newProductModelId !== _.get(this.props, 'reports.courseAbstract.productModelId')) {
      this.sendAnalytics(newProductModelId);
    }
  }

  sendAnalytics(productModelId) {
    let newReportType;
    switch (productModelId) {
      case PRODUCT_MODELS.skills:
        newReportType = REPORT_TYPES.skills;
        break;
      case PRODUCT_MODELS.quantitative:
      case PRODUCT_MODELS.qualitative:
      case PRODUCT_MODELS.goreact:
      case PRODUCT_MODELS.essentials:
        newReportType = REPORT_TYPES.unitOverview;
        break;
      default:
        break;
    }
    if (newReportType) {
      this.props.sendAnalyticsEvent(viewReport(newReportType));
    }
  }

  render() {
    const {
      reports: {
        courseAbstract,
        navigationBar,
      },
      onTabChange,
    } = this.props;

    const containerClass = clsx({
      [s.Container]: true,
      [s.noData]: navigationBar.length === 0,
      [s.newCourseView]: true,
    });

    const getReportToShow = () => {
      if (!courseAbstract || courseAbstract.loading) return null;

      switch (courseAbstract.productModelId) {
        case PRODUCT_MODELS.skills:
          return (<SkillsOverviewReport
            onTabChange={onTabChange}
            courseId={courseAbstract.id}
          />);
        case PRODUCT_MODELS.quantitative:
        case PRODUCT_MODELS.qualitative:
        case PRODUCT_MODELS.goreact:
        case PRODUCT_MODELS.essentials:
          return <ModuleOverview onTabChange={onTabChange} />;
        default:
          return <ReportError />;
      }
    };

    return (
      <div className={containerClass}>
        <div className={s.leftHandNavigation}>
          <div className={s.leftHandNavigationTitle}>Reports Dashboard</div>
          <div className={s.leftHandNavigationContent}>
            <LeftHandNav onTabChange={onTabChange} />
          </div>
        </div>
        <div className={s.reportContainer} data-test-id="reports_tab_container">
          {getReportToShow()}
        </div>
      </div>
    );
  }
}

ReportsContent.propTypes = {
  course: object,
  onTabChange: func,
  reports: object,
  getCourseAbstract: func,
  sendAnalyticsEvent: func,
  match: object,
  loadUnits: func,
  getSkillsNavigationData: func,
};

function mapStateToProps(state) {
  return {
    course: state.courses.course,
    reports: state.reports,
  };
}

const mapDispatchToProps = dispatch => bindActionCreators({ getCourseAbstract, sendAnalyticsEvent, loadUnits, getSkillsNavigationData }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReportsContent);
